module.exports = __webpack_public_path__ + "img/telegram_color.2a69fba4.png";